<template>
  <div class="content-indent-wrapper">
    <div class="content-indent">
      <div class="page-top-title">
        <div class="page-top-title__item">
          <h2 class="content-title">Реестр запросов кп</h2>
        </div>
        <div class="page-top-title__item text-right">
        </div>
      </div>
      <div class="content-tab-area">
        <div class="content-tab__panel tab_active">
          <div class="container-fluid">
            <div class="content-tab-wrapper">
              <div class="content-tab-indent">
                <div class="control-panel">
                  <div class="control-panel__item">
                    <!--          todo Добавить onclick          -->
                    <a title="Открыть XLS"
                       class="control-panel__link control-xls_link"
                    />
                  </div>
                  <div class="control-panel__item">
                    <div class="control-parent_item">
                      <a title="Настройка фильтра"
                         @click="showFilterModal=true"
                         class="control-panel__link control-funnel_link"
                      />
                    </div>
                    <div class="control-parent_item">
                      <a title="Группировка"
                         @click="showGroupModal=true"
                         class="control-panel__link control-diagram_link"
                      />
                    </div>
                  </div>
                  <!--         todo  Потом добавить фильтр по организациям, ручка getListOrgSPAccreditation не работает       -->
                  <div class="control-panel__search">
                    <!--                    <select v-model="filter.status"-->
                    <!--                            @change="fetchInfo"-->
                    <!--                            class="small_search"-->
                    <!--                            style="background: none">-->
                    <!--                      <option value="">Все организации</option>-->
                    <!--                      <option v-for="item in orgSPA" :key="item.ID" :value="item.ID">-->
                    <!--                        &#45;&#45;{{ item.UF_NAME }}-->
                    <!--                      </option>-->
                    <!--                    </select>-->
                  </div>
                </div>
                <!--        Таблица        -->
                <div v-if="accreditationOM && accreditationOM.settings && !isAccreditationOMLoading"
                     class="table-responsive production-area"
                >
                  <table class="production-table_child">
                    <thead>
                    <tr>
                      <th>
                        <input v-model="checkAllBox" @click="checkAll" type="checkbox">
                      </th>
                      <th v-for="item in accreditationOM.settings.reestrFields"
                          class="mob-cell-w_120" v-bind:key="item.NAME"
                      >
                        <div class="table-th-wrap">
                          <span class="table-th-wrap__name">
                            {{ item.NAME }}
                          </span>
                          <i v-if="item.SORT"
                             class="i-panel_orient"
                             :class="{orient_active:sortColumn===item.FIELD,asc:sortOrder==='ASC',desc:sortOrder==='DESC'}"
                             @click="setOrder(item.FIELD)"
                          />
                        </div>
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in accreditationOM.items"
                        v-bind:key="item.ID"
                    >
                      <td>
                        <input type="checkbox" @click="checkItem(item.ID)" :checked="isChecked(item.ID)"/>
                      </td>
                      <td v-for="field in accreditationOM.settings.reestrFields"
                          v-bind:key="field.NAME"
                      >
                        <router-link v-if="field.IS_LINK===1"
                                     :to="{name: 'LK/accreditation/edit', params: { id: item.ID }}"
                        >
                          {{ item[field.FIELD] }}
                        </router-link>
                        <span v-else-if="field.TYPE==='normal'">
                          {{ item[field.FIELD] }}
                        </span>
                        <span v-else-if="field.TYPE==='composite_normal'">
                          {{ compositeValue(item, field.FIELD) }}
                        </span>
                        <span v-else-if="field.TYPE==='composite_array'">
                          <span v-for="object in compositeArrayValue(item, field.FIELD)"
                                v-bind:key="object"
                          >
                            {{ object }}
                          </span>
                        </span>
                      </td>
                    </tr>
                    <tr v-for="(gitem, gindex) in glist"
                        v-bind:key="gitem.ID"
                    >
                      <td v-if="!gitem.isItem && !gitem.hide"
                          :colspan="accreditationOM.settings.reestrFields.length+1"
                      >
                        <span :style="{marginLeft: gitem.deep*10+'px'}"/>
                        <a style="color:black;font-weight: bold;"
                           @click="toggleGroup(gindex)"
                        >
                          <span class="row-parent_switch"
                                :class="{'row-parent_switch_close':!gitem.hideNext}"
                          />
                          {{ gitem.name }}
                        </a>
                      </td>
                      <td v-if="gitem.isItem && !gitem.hide">
                        <span :style="{marginLeft: gitem.deep*10+'px'}"/>
                        <input type="checkbox"
                               @click="checkItem(gitem.it.ID)"
                               :checked="isChecked(gitem.it.ID)"
                        />
                      </td>
                      <template v-if="gitem.isItem && !gitem.hide">
                        <td v-for="field in accreditationOM.settings.reestrFields"
                            v-bind:key="field.NAME"
                        >
                          <router-link v-if="field.FIELD==='UF_REG_NUMBER'"
                                       :to="{name: 'LK/accreditation/edit', params: { id: gitem.it.ID }}"
                          >
                            {{ gitem.it.UF_REG_NUMBER }}
                          </router-link>
                          <span v-else-if="field.TYPE==='normal'">
                            {{ gitem.it[field.FIELD] }}
                          </span>
                          <span v-else-if="field.TYPE==='composite_normal'">
                            {{ compositeValue(gitem.it, field.FIELD) }}
                          </span>
                          <span v-else-if="field.TYPE==='composite_array'">
                            <span v-for="object in compositeArrayValue(gitem.it, field.FIELD)"
                                  v-bind:key="object"
                            >
                              {{ object }}
                            </span>
                          </span>
                        </td>
                      </template>
                    </tr>
                    </tbody>
                  </table>
                  <div class="main-pagination table-pagination">
                    <Pagination
                        :pages="pages"
                        :currentPage.sync="currentPage"/>
                    <span class="pagination_all">Всего: {{ accreditationOM.counts }}</span>
                    <span>Выводить по: </span>
                    <select class="pagination__select" v-model="itemsPerPage">
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                    </select>
                  </div>
                </div>
              </div>

              <!--       Модальное окно для группировки элементов таблицы       -->
              <div v-if="showGroupModal"
                   class="modal fade in show"
                   tabindex="-1"
                   role="dialog"
                   aria-labelledby="myModalLabel"
              >
                <div class="modal-dialog modal-middle"
                     role="document"
                >
                  <div class="modal-content">
                    <div class="modal-add-document">
                      <div class="modal-header main-clear">
                        <span class="modal-title">настройка группировки</span>
                        <a @click="showGroupModal=false" class="modal-exit stl-FR"/>
                      </div>
                      <div class="modal-body">
                        <div class="modal_row main-clear">
                          <div class="table-responsive">
                            <table class="filter-table">
                              <tbody>
                              <tr v-for="(group, gi) in groups"
                                  :key="group.name"
                              >
                                <td>
                                  <select v-model="group.index"
                                          class="main_input main_select filter-input"
                                  >
                                    <option v-for="item in groupFields(gi, accreditationOM.settings.groupFields)"
                                            :key="item.NAME"
                                            :value="item.POS"
                                    >
                                      {{ item.NAME }}
                                    </option>
                                  </select>
                                </td>
                                <td>уровень {{ gi + 1 }}</td>
                                <td class="text-center">
                                  <a @click="groups.splice(gi, 1)">
                                    <i class="control-delete_link"/>
                                  </a>
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div class="modal_row">
                          <a v-if="groupFields(-1, accreditationOM.settings.groupFields).length > 0"
                             @click="groups.push({})"
                             class="control-panel__link control-add_link"
                          >
                            добавить уровень группировки
                          </a>
                        </div>
                        <div class="modal_row main-clear">
                          <div class="link_style-blue modal-full_wid"
                               @click="fetchInfo"
                          >
                            применить
                          </div>
                          <div class="link_style-blue link_style-reset modal-full_wid"
                               @click="clearGroups"
                          >
                            сбросить группировку
                          </div>
                          <div class="link_style-white modal-full_wid"
                               @click="showGroupModal = false"
                          >
                            отмена
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!--       Модальное окно для фильтрации элементов таблицы       -->
              <div v-if="showFilterModal"
                   class="modal fade in show"
                   tabindex="-1"
                   role="dialog"
                   aria-labelledby="myModalLabel"
              >
                <div class="modal-dialog"
                     role="document"
                >
                  <div class="modal-content">
                    <div class="modal-add-document modal-full">
                      <div class="modal-header main-clear">
                        <span class="modal-title">настройка фильтра</span>
                        <a @click="showFilterModal=false"
                           class="modal-exit stl-FR"
                        />
                      </div>
                      <div class="modal-body">
                        <div class="modal_row main-clear">
                          <div class="table-responsive">
                            <table class="filter-table">
                              <tbody>
                              <tr v-for="(filter, fi) in filters"
                                  :key="filter.name"
                              >
                                <td>
                                  <select @change="changeFilterIndex(filter)"
                                          v-model="filter.index"
                                          class="main_input main_select filter-input"
                                  >
                                    <option v-for="(item, index) in accreditationOM.settings.filterFields"
                                            :key="item.NAME"
                                            :value="index"
                                    >
                                      {{ item.NAME }}
                                    </option>
                                  </select>
                                </td>
                                <td>
                                  <select v-model="filter.operation"
                                          class="main_input main_select filter-input"
                                  >
                                    <option
                                        v-for="(item, index) in accreditationOM.settings.filterFields[filter.index].OPERATION"
                                        :key="item.NAME"
                                        :value="index"
                                    >
                                      {{ item.NAME }}
                                    </option>
                                  </select>
                                </td>
                                <td style="width: 250px">
                                  <input
                                      v-if="accreditationOM.settings.filterFields[filter.index].FIELD_TYPE==='string'"
                                      type="text" class="main_input filter-input"
                                      v-model="filter.value"
                                  >
                                  <input
                                      v-if="accreditationOM.settings.filterFields[filter.index].FIELD_TYPE==='string' && accreditationOM.settings.filterFields[filter.index].OPERATION[filter.operation].CNT_VALUE===2"
                                      type="text" class="main_input filter-input"
                                      style="margin-top: 5px"
                                      v-model="filter.value2"
                                  >
                                  <Multiselect
                                      v-if="accreditationOM.settings.filterFields[filter.index].FIELD_TYPE==='multiselect'"
                                      label="UF_NAME"
                                      :loading="!filter.listRendered"
                                      :limit="1"
                                      :limitText="filterItemText"
                                      track-by="ID"
                                      v-model="filter.multivalue"
                                      :options="filter.objects"
                                      :multiple="true" placeholder=""
                                  />
                                  <Multiselect
                                      v-if="accreditationOM.settings.filterFields[filter.index].FIELD_TYPE==='multiselect' && accreditationOM.settings.filterFields[filter.index].OPERATION[filter.operation].CNT_VALUE===2"
                                      label="UF_NAME"
                                      :loading="!filter.listRendered"
                                      :limit="1"
                                      :limitText="filterItemText"
                                      track-by="ID"
                                      v-model="filter.multivalue2"
                                      :options="filter.objects"
                                      :multiple="true" placeholder=""
                                      style="margin-top: 5px"
                                  />
                                  <datepicker
                                      v-if="accreditationOM.settings.filterFields[filter.index].FIELD_TYPE==='datetime'"
                                      v-model="filter.value"
                                      :language="ru"
                                      :format="dateFormat" style="width: 100%"
                                      input-class="main_input filter-input"
                                  />
                                  <datepicker
                                      v-if="accreditationOM.settings.filterFields[filter.index].FIELD_TYPE==='datetime' && accreditationOM.settings.filterFields[filter.index].OPERATION[filter.operation].CNT_VALUE===2"
                                      v-model="filter.value2"
                                      :language="ru"
                                      :format="dateFormat"
                                      style="margin-top: 5px;width: 100%"
                                      input-class="main_input filter-input"
                                  />
                                  <select
                                      v-if="accreditationOM.settings.filterFields[filter.index].FIELD_TYPE==='select'"
                                      type="text" class="main_input filter-input"
                                      v-model="filter.value"
                                  >
                                    <option v-for="item in filter.objects"
                                            :key="item.ID"
                                            :value="item.ID"
                                    >
                                      {{ item.UF_NAME }}
                                    </option>
                                  </select>
                                </td>
                                <td>
                                  <select v-model="filter.logic"
                                          class="main_input main_select filter-input"
                                  >
                                    <option
                                        v-for="(item, index) in accreditationOM.settings.filterFields[filter.index].LOGIC"
                                        :key="item.NAME"
                                        :value="index"
                                    >
                                      {{ item.NAME }}
                                    </option>
                                  </select>
                                </td>
                                <td class="text-center">
                                  <a @click="filters.splice(fi, 1)">
                                    <i class="control-delete_link"/>
                                  </a>
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div class="modal_row">
                          <a class="control-panel__link control-add_link"
                             @click="filters.push({index:0, operation:0, logic: 0, value: '', value2: '', objects:[], listRendered: false, multivalue:[], multivalue2:[]})">
                            добавить фильтр
                          </a>
                        </div>
                        <div class="modal_row main-clear">
                          <div class="link_style-blue modal-full_wid" @click="fetchInfo">
                            применить
                          </div>
                          <div class="link_style-blue link_style-reset modal-full_wid" @click="clearFilters()">
                            сбросить фильтры
                          </div>
                          <div class="link_style-white modal-full_wid" @click="showFilterModal=false">
                            отмена
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapGetters} from "vuex";
import Pagination from "@/components/site/Pagination";
import moment from "moment";
import {ru} from "vuejs-datepicker/dist/locale";
import ApiService from "@/common/api.service";
import Vue from "vue";
import Datepicker from "vuejs-datepicker";
import Multiselect from "vue-multiselect";

export default {
  name: "Accreditation",
  components: {Pagination, Datepicker, Multiselect},

  data() {
    return {
      metaTitle: '',
      itemsPerPage: 20,
      currentPage: 1,
      sortColumn: "UF_DATE_CREATE",
      sortOrder: "DESC",
      ru: ru,
      showFilterModal: false,
      showGroupModal: false,
      checkedItems: [],
      checkAllBox: false,
      groups: [],
      filters: [],
      applyFilters: [],
      applyGroups: [],
      glist: [],
    };
  },

  async mounted() {
    await this.fetchInfo();
  },

  computed: {
    ...mapGetters([
      "accreditationOM",
      "isAccreditationOMLoading",
      "isAccreditationOMLoadingError",
      "orgSPA",
      "directory"
    ]),
    listConfig() {
      const q = {
        page: this.currentPage,
        limit: this.itemsPerPage,
        filter: "",
        group: [],
      };
      if (this.sortColumn !== "") {
        let sort = {
          column: "",
          order: ""
        };
        sort.column = this.sortColumn;
        sort.order = this.sortOrder;
        q.sort = sort;
      }
      let filterarr = []
      this.filters.forEach(function (filter) {
        filterarr.push({
          FIELD: this.accreditationOM.settings.filterFields[filter.index].FIELD,
          OPERATION: this.accreditationOM.settings.filterFields[filter.index].OPERATION[filter.operation].CODE,
          VALUE: filter.value, VALUE2: filter.value2,
          LOGIC: this.accreditationOM.settings.filterFields[filter.index].LOGIC[filter.logic].CODE,
          RUNTIME: this.accreditationOM.settings.filterFields[filter.index].RUNTIME,
          CODE_RUNTIME: this.accreditationOM.settings.filterFields[filter.index].CODE_RUNTIME
        })
      }, this);
      q.filter = ""
      if (filterarr.length) {
        q.filter = Buffer.from(JSON.stringify(filterarr)).toString("base64");
      }
      if (this.filters.length > 0) {
        Vue.set(this, 'applyFilters', JSON.parse(JSON.stringify(this.filters)))
      }
      this.groups.forEach(function (group) {
        q.group.push(this.accreditationOM.settings.groupFields[group.index].FIELD)
      }, this);

      if (this.groups.length > 0) {
        Vue.set(this, 'applyGroups', JSON.parse(JSON.stringify(this.groups)))
      }
      return q;
    },
    pages() {
      if (this.isAccreditationOMLoading || this.accreditationOM.counts <= this.itemsPerPage) {
        return [];
      }
      return [
        ...Array(Math.ceil(this.accreditationOM.counts / this.itemsPerPage)).keys()
      ].map(e => e + 1);
    }
  },

  watch: {
    currentPage(newValue) {
      this.listConfig.page = newValue;
      this.fetchInfo();
    },
    itemsPerPage(newValue) {
      this.listConfig.limit = newValue;
      this.fetchInfo();
    }
  },

  filters: {
    dateFormat(date) {
      return moment(date).format("DD.MM.YYYY");
    },
  },

  methods: {
    // Запрос информации для заполнения таблицы и фильтра по организациям
    fetchInfo() {
      this.$store.dispatch('fetchAccreditationOMs', this.listConfig).then(() => {
        document.title = unescape(this.accreditationOM.META_TITLE);
        this.showFilterModal = false
        this.showGroupModal = false
        if (this.accreditationOM.group.length > 0) {
          this.glist = []
          this.appendq(this.accreditationOM.group, 0)
        }
      }, this)
      this.$store.dispatch('fetchOrgSPA');
    },

    setOrder(column) {
      if (this.sortColumn !== column) {
        this.sortOrder = "ASC";
      } else {
        if (this.sortOrder === "DESC") {
          this.sortOrder = "";
          this.sortColumn = "";
        } else {
          this.sortOrder = "DESC";
        }
      }
      this.sortColumn = column;
      this.fetchInfo();
    },

    appendq(items, deep) {
      items.forEach(function (item) {
        this.glist.push({name: item.GROUP_NAME, deep: deep, isItem: false, hide: false, hideNext: false})
        if (item.GROUP_CHILDS.length) {
          this.appendq(item.GROUP_CHILDS, deep + 1)
        } else {
          item.GROUP_CHILDS.items.forEach(function (it) {
            this.glist.push({name: item.GROUP_NAME, deep: deep, isItem: true, it: it, hide: false})
          }, this)
        }
      }, this)
    },

    toggleGroup(ind) {
      let isStarted = false
      let deep = 0
      let hide = false
      this.glist.forEach(function (item, index) {
        if (isStarted && item.deep <= deep && !item.isItem) {
          isStarted = false
        }
        if (isStarted && item.deep >= deep) {
          item.hide = hide
          item.hideNext = hide
        }
        if (ind === index) {
          isStarted = true
          deep = item.deep
          item.hideNext = !item.hideNext
          hide = item.hideNext
        }
      }, this)
    },

    dateFormat(date) {
      return moment(date).format("DD.MM.YYYY");
    },

    compositeValue(item, field) {
      let fields = field.split('.')
      function gv(item, f) {
        return item[f];
      }
      let f = item;
      fields.forEach(function (v) {
        f = gv(f, v)
      })
      return f;
    },

    compositeArrayValue(item, field) {
      let fields = field.split('.')
      function gv(item, f) {
        return item[f];
      }
      let f = item;
      fields.forEach(function (v, i) {
        if (i < fields.length - 1) {
          f = gv(f, v)
        }
      })
      let ret = []
      f.forEach(function (v) {
        ret.push(v[fields[fields.length - 1]])
      })
      return ret;
    },

    isChecked(id) {
      return this.checkedItems[id]
    },

    checkAll() {
      this.accreditationOM.items.forEach(function (i) {
        this.checkedItems[i.ID] = !this.checkAllBox
      }, this)
      this.glist.forEach(function (i) {
        if (i.isItem) {
          this.checkedItems[i.it.ID] = !this.checkAllBox
        }
      }, this)
    },

    checkItem(id) {
      if (this.checkedItems[id]) {
        delete this.checkedItems[id]
        this.checkAllBox = false
      } else {
        this.checkedItems[id] = true
      }
    },

    changeFilterIndex(filter) {
      filter.value = ""
      filter.value2 = ""
      filter.operation = 0
      filter.logic = 0
      filter.multivalue = []
      filter.multivalue2 = []
      if (this.accreditationOM.settings.filterFields[filter.index].LINK) {
        filter.listRendered = false
        ApiService.get2(this.accreditationOM.settings.filterFields[filter.index].LINK).then(({data}) => {
          filter.objects = data
          Vue.set(filter, 'listRendered', true)
        }, this)
      }
    },

    filterItemText(count) {
      return `и еще ${count}`
    },

    groupFields(index, fields) {
      let ret = []
      fields.forEach(function (f, fin) {
        let hasAdd = false
        this.groups.forEach(function (gr, gin) {
          if (index !== gin) {
            if (gr.index === fin) {
              hasAdd = true
            }
          }
        }, this)
        if (!hasAdd) {
          ret.push({NAME: f.NAME, POS: fin})
        }
      }, this)
      return ret
    },

    filterString() {
      let str = ""
      if (this.applyFilters.length > 0) {
        str += `Фильтр: `
        this.applyFilters.forEach(function (filter, ind) {
          let f = this.accreditationOM.settings.filterFields[filter.index]
          if (filter.value) {
            str += ` ${f.NAME} ${f.OPERATION[filter.operation].NAME} "${filter.value}"`
            if (filter.value2) {
              str += ` и "${filter.value2}"`
            }
            if (this.applyFilters[ind + 1] && (this.applyFilters[ind + 1].value || this.applyFilters[ind + 1].multivalue.length > 0)) {
              str += ` <strong>${f.LOGIC[filter.logic].NAME}</strong> `
            }
          }
          if (filter.multivalue.length > 0) {
            str += ` ${f.NAME} ${f.OPERATION[filter.operation].NAME} `
            filter.multivalue.forEach(function (val, i) {
              if (i > 0) {
                str += ', '
              }
              str += `"${val.UF_NAME}"`
            })

            if (this.applyFilters[ind + 1] && (this.applyFilters[ind + 1].value || this.applyFilters[ind + 1].multivalue.length > 0)) {
              str += ` <strong>${f.LOGIC[filter.logic].NAME}</strong> `
            }
          }
        }, this)
      }
      return str
    },

    groupString() {
      let str = ""
      if (this.applyGroups.length > 0) {
        str += `Группировка: `
        this.applyGroups.forEach(function (group, i) {
          if (i > 0) {
            str += ", "
          }
          str += this.accreditationOM.settings.groupFields[group.index].NAME
        }, this);
      }
      return str
    },

    clearFilters() {
      this.filters = []
      this.showFilterModal = false
      Vue.set(this, 'applyFilters', [])
      this.fetchInfo()
    },

    clearGroups() {
      this.groups = []
      this.showGroupModal = false
      Vue.set(this, 'applyGroups', [])
      this.fetchInfo()
    }
  }
}
</script>

<style scoped>
</style>